import { registerUsers } from "./register";
import { loginUser } from "./login";
import { forgotPass } from "./forgotPassword";
import "../../CSS/authorization.css";

export function createAuth() {
  const authorization = document.createElement("div");
  authorization.classList = "authorization";
  document.body.appendChild(authorization);

  const form = document.createElement("form");
  form.id = "authForm";
  authorization.appendChild(form);

  // Authorization

  const blank = document.createElement("div");
  blank.classList = "auth__background";
  form.appendChild(blank);

  const formTitle = document.createElement("h1");
  formTitle.textContent = "Prisijungti";
  formTitle.classList = "auth__title";
  blank.appendChild(formTitle);

  const emailLabel = document.createElement("label");
  emailLabel.textContent = "el. paštas:";
  emailLabel.textContent = emailLabel.textContent.toUpperCase();
  form.appendChild(emailLabel);

  const emailInput = document.createElement("input");
  emailInput.type = "email";
  emailInput.name = "email";
  emailInput.id = "email";
  emailInput.required = true;
  form.appendChild(emailInput);

  const passwordLabel = document.createElement("label");
  passwordLabel.textContent = "Slaptažodis:";
  passwordLabel.textContent = passwordLabel.textContent.toUpperCase();
  form.appendChild(passwordLabel);

  const passwordInput = document.createElement("input");
  passwordInput.type = "password";
  passwordInput.name = "password";
  passwordInput.id = "password";
  passwordInput.required = true;
  form.appendChild(passwordInput);

  const allerts = document.createElement("div");
  allerts.id = "allerts";
  allerts.style.height = "50px";
  form.appendChild(allerts);

  // Forgot Password
  const forgotPasswordLink = document.createElement("p");
  forgotPasswordLink.id = "forgotPass";
  forgotPasswordLink.classList = "forgotPass";
  forgotPasswordLink.innerHTML = "Pamiršau slaptažodį";
  form.insertBefore(forgotPasswordLink, allerts);

  const submitButton = document.createElement("button");
  submitButton.textContent = "Prisijungti";
  submitButton.textContent = submitButton.textContent.toUpperCase();
  submitButton.id = "auth";
  form.appendChild(submitButton);

  const switchFormButton = document.createElement("button");
  switchFormButton.textContent = "Registracija";
  switchFormButton.textContent = switchFormButton.textContent.toUpperCase();
  switchFormButton.id = "switch";
  switchFormButton.setAttribute("type", "button");
  form.appendChild(switchFormButton);

  const closeFormButton = document.createElement("button");
  closeFormButton.textContent = "Uždaryti";
  closeFormButton.textContent = closeFormButton.textContent.toUpperCase();
  closeFormButton.id = "close";
  closeFormButton.setAttribute("type", "button");
  form.appendChild(closeFormButton);

  // Add event listener to switch form
  switchFormButton.addEventListener("click", () => {
    if (formTitle.textContent === "Prisijungti") {
      // Change form title
      formTitle.textContent = "Registracija";

      // Clear error messages
      clearErrors();

      // Change submit button text
      submitButton.textContent = "Registracija";
      submitButton.textContent = submitButton.textContent.toUpperCase();

      // Change switch form button text
      switchFormButton.textContent = "Prisijungti";
      switchFormButton.textContent = switchFormButton.textContent.toUpperCase();

      // Add repeat password input
      const repeatPasswordLabel = document.createElement("label");
      repeatPasswordLabel.id = "repeatPasswordLabel";
      repeatPasswordLabel.textContent = "Pakartokite slaptažodį:";
      repeatPasswordLabel.textContent =
        repeatPasswordLabel.textContent.toUpperCase();
      form.insertBefore(repeatPasswordLabel, allerts);

      const repeatPasswordInput = document.createElement("input");
      repeatPasswordInput.type = "password";
      repeatPasswordInput.id = "repeatPassword";
      repeatPasswordInput.required = true;
      form.insertBefore(repeatPasswordInput, allerts);

      // Remove forgot password
      const forgotPasswordLink = document.getElementById("forgotPass");
      if (forgotPasswordLink) {
        forgotPasswordLink.remove();
      }
    } else {
      formTitle.textContent = "Prisijungti";

      // Clear error messages
      clearErrors();

      // Remove repeat password
      const repeatPasswordLabel = document.getElementById(
        "repeatPasswordLabel"
      );
      const repeatPasswordInput = document.getElementById("repeatPassword");
      if (repeatPasswordInput) {
        repeatPasswordLabel.remove();
        repeatPasswordInput.remove();
      }

      // Change submit button text
      submitButton.textContent = "Prisijungti";
      submitButton.textContent = submitButton.textContent.toUpperCase();

      // Change switch form button text
      switchFormButton.textContent = "Registracija";
      switchFormButton.textContent = switchFormButton.textContent.toUpperCase();

      // Forgot Password
      const forgotPasswordLink = document.createElement("p");
      forgotPasswordLink.id = "forgotPass";
      forgotPasswordLink.classList = "forgotPass";
      forgotPasswordLink.innerHTML = "Pamiršau slaptažodį";
      form.insertBefore(forgotPasswordLink, allerts);
    }
  });

  forgotPasswordLink.addEventListener("click", (e) => {
    e.preventDefault();
    form.remove();
    forgotPass();
  });

  // Add event listener to form submit button
  submitButton.addEventListener("click", (event) => {
    event.preventDefault(); // Prevent form submission
    window.localStorage.clear();

    // Clear error messages
    clearErrors();

    if (
      !validateEmail(emailInput.value) ||
      !validatePassword(passwordInput.value)
    ) {
      allerts.classList = "errorAllerts";
      // Validate email
      if (!validateEmail(emailInput.value)) {
        setError("email", "Netinkamas el. pašto formatas.");
      }

      // Validate password
      if (!validatePassword(passwordInput.value)) {
        setError("password", "Slaptažodis turi būti bent 8 simbolių ilgio.");
      }
      return;
    }

    if (formTitle.textContent === "Registracija") {
      const repeatPasswordInput = document.getElementById("repeatPassword");

      // Check if repeat password matches password
      if (repeatPasswordInput.value !== passwordInput.value) {
        allerts.classList = "errorAllerts";
        setError("repeatPassword", "Slaptažodžiai nesutampa.");
        return;
      }
      registerUsers();
      document.getElementById("auth").disabled = true;
      submitButton.textContent = "Kraunasi...";
    } else {
      loginUser();
      document.getElementById("auth").disabled = true;
      submitButton.textContent = "Kraunasi...";
    }
  });

  function validateEmail(email) {
    // Regular expression to validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function validatePassword(password) {
    // Regular expression to validate password format
    const passwordRegex = /^[a-zA-Z0-9]{8,}$/;
    return passwordRegex.test(password);
  }

  function setError(inputName, errorMessage) {
    const input = document.getElementById(inputName);
    input.classList.add("error");
    const error = document.createElement("div");
    error.classList.add("error-message");
    error.textContent = errorMessage;
    document.getElementById("allerts").appendChild(error);
  }

  function clearErrors() {
    const inputs = document.querySelectorAll("input");
    inputs.forEach((input) => {
      input.classList.remove("error");
      const error = input.parentNode.querySelector(".error-message");
      if (error) {
        error.remove();
      }
    });
    allerts.removeAttribute("class");
    allerts.textContent = "";
  }

  closeFormButton.addEventListener("click", () => {
    document.querySelector(".authorization").remove();
    if (document.querySelector("#game")) {
      document.querySelector("#game").style.display = "block";
    } else {
      document.querySelector("#menu").style.display = "flex";
    }
    document.getElementById("authorization").removeAttribute("style");
  });
}
